import { render } from "./TestimonialsView.vue?vue&type=template&id=08e2ed0c&scoped=true"
import script from "./TestimonialsView.vue?vue&type=script&lang=js"
export * from "./TestimonialsView.vue?vue&type=script&lang=js"

import "./TestimonialsView.vue?vue&type=style&index=0&id=08e2ed0c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08e2ed0c"]])

export default __exports__